import Image from './_image.js'
import FlexContainerBase from './_flex-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import Animation from './_animation.js'

export default {
  name: 'Spinner',
  values: {
    image: {
      configSet: Image,
      configValues: {
        src: 'spinner',
        style: {
          flexShrink: 0,
          flexBasis: '16px',
        },
      },
    },
    style: {
      container: {
        flexBasis: '16px',
        height: '16px',
        justifyContent: 'center',
        $mixin: [
          {
            configSet: FlexContainerBase,
          },
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      iconAnimation: {
        configSet: Animation,
        configValues: {
          animationDuration: '1s',
          animationTimingFunction: 'linear',
          animationIterationCount: 'infinite',
          keyframes: {
            from: {
              transform: 'rotate(0)',
            },
            to: {
              transform: 'rotate(360deg)',
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
